module.exports = __webpack_public_path__ + "img/ruler-horizontal.d5e2c7c1.svg";